import { z } from 'zod'
import { zId, zIsoDate, zJsonBlob } from '../common'
import { zSiteStatus } from '../enums'

// A site under autopilot. Creating a site also creates its sitemap knowledge
// source server-side and enqueues the first ingest.
export const zSite = z.object({
  id: zId,
  name: z.string(),
  slug: z.string(),
  siteUrl: z.string(),
  // Main language (e.g. 'fr'); additionalLanguages lists the extra markets.
  language: z.string(),
  additionalLanguages: z.array(z.string()).nullish().default([]),
  // Locale → landing-path base, shape owned by the server (displayed as-is).
  locales: z.unknown().optional(),
  // Google geo target constant ids (e.g. 2250 = France).
  defaultGeoTargets: z.array(z.union([z.string(), z.number()]).transform(String))
    .nullish()
    .default([]),
  // '/{locale}' or '' — how locale prefixes map to URL paths.
  localePathTemplate: z.string().nullish().default(''),
  status: zSiteStatus,
  monthlyLlmCapCents: z.number().nullish().default(null),
  budgetDailyCeilingMicros: z.number().nullish().default(null),
  brandSettings: zJsonBlob.nullish().default(null),
  createdAt: zIsoDate,
  updatedAt: zIsoDate,
})
export type Site = z.infer<typeof zSite>
